export default __webpack_public_path__ + "static/media/tenis10_1225x220px.8216f9f1.jpg";